import { useEffect, useState } from 'react';

export const useMapMarker = (options: google.maps.MarkerOptions, hideMarker = false) => {
  const [marker, setMarker] = useState<google.maps.Marker>();

  useEffect(
    function initializeMarker() {
      if (hideMarker) {
        return;
      }

      if (marker) {
        return () => marker.setMap(null);
      }

      setMarker(new google.maps.Marker());
    },
    [marker]
  );

  useEffect(
    function setMarkerOptions() {
      if (hideMarker) {
        return;
      }

      marker?.setOptions(options);
    },
    [marker, options]
  );

  return marker;
};
